export default __webpack_public_path__ + "fonts/initiator.b2130d11e7dc7579cd963985cc58c801.png";